import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useDrodDetailModel } from "./drodDetailModel";
import { RouterParamType } from "@/model/navModel";
import { IDrodTabEnum } from "../../drodTypes";
import { BaseDetail } from "./base";
import { RelevanceTask } from "./task";
import { Files } from "./files";
import { CustomsClearance } from "./customsClearance";
import { Invoice } from "./invoice";
import { Encasement } from "./encasement";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = useDrodDetailModel(({ tabActive }) => [tabActive]);
    const isEdit = detailsInfo.mode === "edit";

    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            // case IDrodTabEnum.BASE_DETAIL:
            //     return <BaseDetail {...detailsInfo}/>;
            case IDrodTabEnum.RELEVANCE_TASK:
                return <RelevanceTask {...detailsInfo} />;
            case IDrodTabEnum.FILES:
                return <Files {...detailsInfo} />;
            case IDrodTabEnum.CUSTOMS_CLEARANCE:
                return <CustomsClearance {...detailsInfo} />;
            case IDrodTabEnum.INVOICE:
                return <Invoice {...detailsInfo} />;
            case IDrodTabEnum.ENCASEMENT:
                return <Encasement {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: IDrodTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }
    const action = <>
        <Button
            className={classname(IDrodTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDrodTabEnum.BASE_DETAIL)}
        >基本信息</Button>
         <Button
            hidden={!isEdit}
            className={classname(IDrodTabEnum.CUSTOMS_CLEARANCE)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDrodTabEnum.CUSTOMS_CLEARANCE)}
        >报关单</Button>
        {/* <Button
            hidden={!isEdit}
            className={classname(IDrodTabEnum.INVOICE)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDrodTabEnum.INVOICE)}
        >商业发票</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDrodTabEnum.ENCASEMENT)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDrodTabEnum.ENCASEMENT)}
        >装箱单</Button> */}
        <Button
            hidden={!isEdit}
            className={classname(IDrodTabEnum.RELEVANCE_TASK)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDrodTabEnum.RELEVANCE_TASK)}
        >关联单据</Button>
        <Button
            hidden={!isEdit}
            className={classname(IDrodTabEnum.FILES)}
            type="link"
            shape="round"
            onClick={() => setTabActive(IDrodTabEnum.FILES)}
        >附件管理</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== IDrodTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div>
            <RenderTabItem />
        </>
    )
}